import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white shadow rounded-md h-full overflow-auto" }
const _hoisted_2 = {
  key: 0,
  class: "p-4 h-full flex flex-col gap-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "loadingEl h-4 rounded-md bg-gray-50",
  style: { width: '40%' }
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "loadingEl flex-1 rounded-md bg-gray-50" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { EllipsisVerticalIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import DashboardDragHandle from "@/views/dashboard/componentsV2/DashboardDragHandle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseWidget',
  props: {
    isLoading: { type: Boolean },
    hideDragHandle: { type: Boolean },
    menuClass: {}
  },
  emits: ["delete"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["absolute top-3 right-2 z-50", _ctx.menuClass])
        }, [
          _createVNode(_unref(Menu), {
            as: "div",
            class: "relative vgl-item__menu"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuButton), { class: "flex items-center text-gray-600" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(EllipsisVerticalIcon), { class: "w-6 h-6" })
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItems), {
                class: "absolute -right-3 z-50 mt-2 origin-top-right rounded-md overflow-hidden bg-white shadow focus:outline-none",
                style: { width: '200px' }
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "menuItems"),
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
                  }, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                active ? 'bg-gray-100 text-yellow-600' : 'text-gray-700',
                'px-4 py-2 text-sm cursor-pointer truncate flex items-center gap-2',
              ])
                      }, [
                        _createVNode(_unref(XMarkIcon), { class: "w-5 h-5" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.remove_widget")), 1)
                      ], 2)
                    ]),
                    _: 1
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.hideDragHandle && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(DashboardDragHandle, {
          key: 2,
          class: "absolute left-4 z-50 top-[17px]"
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? _renderSlot(_ctx.$slots, "default", { key: 3 })
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "modals")
  ]))
}
}

})